<template>
  <div class="not-found-container">
    <div class="not-found-content">
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>This is not the page you are looking for.</p>
      <router-link to="/console/getstarted" class="home-link">Return to Console</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style scoped lang="scss">

@import '@/assets/styles/NotFound.scss'

</style>